<template>
  <div>
    <v-container style="max-width: unset" class="d-flex-column pa-6">
      <HeaderResale
          :arrow="false"
          title="Seja um revendedor"
          text="Cadastre-se como revendedor, fornecendo seus dados básicos para ativar a conta e ter acesso às ferramentas de vendas disponíveis"
          :haveAction="false"
      />

      <!--Informação Pessoais -->
      <v-card v-if="true" class="mx-auto">
        <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
          >mdi-account-outline</v-icon
        >
        <span class="text-span" style="v-cardAdd">Informações do Revendedor</span>

        <span class="pl-12 pb-2" style="display: block">
          Informações pessoais para cadastro</span
        >

        <v-form
          class="form"
          :key="clear"
          ref="firstForm"
          v-model="firstValid"
          lazy-validation
        >
          <v-row class="pa-6 pb-0 ma-0">
            <v-col cols="12" sm="6" md="6" lg="4">
              <v-text-field
                clearable
                outlined
                maxlength="45"
                v-model="currentResale.name"
                :rules="[rules.nameRules]"
                :label="'Razão Social'"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="4">
              <v-text-field
                clearable
                outlined
                maxlength="45"
                :rules="[rules.nameRules]"
                v-model="currentResale.nameFantasy"
                :label="'Nome Fantasia'"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="4">
              <v-text-field
                clearable
                outlined
                v-model="currentResale.cnpj"
                :rules="[rules.required, rules.validateCPF, rules.validateCNPJ]"
                v-mask="this.isEditing  ? null  : currentResale.cnpj.length <= 14 ? '###.###.###-##' : '##.###.###/####-##'"
                :label="'CNPJ/CPF'"
                rounded
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="4">
              <v-text-field
                clearable
                outlined
                hide-details
                maxlength="14"
                v-mask="'###############'"
                v-model="currentResale.inscrEstadual"
                :rules="[rules.required]"
                label="Inscrição Estadual"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="4">
              <v-text-field
                outlined
                hide-details
                :rules="[rules.required, rules.minPhone]"
                v-model="currentResale.phoneNumber"
                v-mask="
                  this.isEditing
                    ? null
                    : currentResale.phoneNumber.length <= 14
                    ? '(##) ####-####'
                    : '(##) #####-####'
                "
                label="Telefone"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="4">
              <v-text-field
                outlined
                hide-details
                v-model="currentResale.phoneNumber2"
                v-mask="
                  this.isEditing
                    ? null
                    : currentResale.phoneNumber2.length <= 14
                    ? '(##) ####-####'
                    : '(##) #####-####'
                "
                label="Celular (Opcional)"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="6" lg="4">
              <v-select
                outlined
                hide-details
                :rules="[rules.required]"
                :items="categorias"
                v-model="currentResale.category"
                label="Categoria"
                required
              ></v-select>
            </v-col> -->
            <v-col cols="12" sm="6" md="6" lg="4">
              <v-select
                outlined
                :items="regions"
                :rules="[rules.required]"
                hide-details
                v-model="currentResale.region"
                label="Região"
                required
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="flex-end pa-6 pb-3 pt-1 ma-0">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-textarea
                outlined
                hide-details
                label="Observações"
                v-model="currentResale.textObservation"
                rows="1"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card>

      <!--Endereço -->
      <v-card v-if="true" class="mx-auto">
        <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
          >mdi-google-maps
        </v-icon>
        <span class="text-span" style="mx-auto">Endereço</span>

        <span class="pl-12 pb-2" style="display: block"> Localidade da Revenda.</span>

        <v-form
          class="form"
          :key="clear"
          ref="secondForm"
          v-model="secondValid"
          lazy-validation
        >
          <v-row class="pa-6 pb-0 ma-0">
            <v-col cols="12" sm="12" md="6" lg="6">
              <v-text-field
                outlined
                label="CEP"
                :rules="[rules.postalCodeRules]"
                v-model="currentResale.postalCode"
                v-on:keyup="searchCEP"
                v-mask="this.isEditing ? cepMask : '#####-###'"
                class="inputCep"
              ></v-text-field>
              <p v-show="naoLocalizado" style="display: none; background-color: #f1948a">
                <strong>CEP não localizado.</strong> Por gentileza entre manualmente.
              </p>
            </v-col>

            <v-col cols="12" sm="12" md="6" lg="6">
              <a
                href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                target="_blank"
                >Não sei meu CEP</a
              >
            </v-col>
          </v-row>

          <v-row class="pa-6 pt-0 pb-3 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-select
                outlined
                hide-details
                :rules="[rules.required]"
                :items="estados"
                label="Estado"
                v-model="currentResale.state"
                color="secondary"
                id="mb-8"
                required
              ></v-select>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                outlined
                hide-details
                :rules="[rules.required]"
                label="Cidade"
                v-model="currentResale.city"
                color="secondary"
                id="inputCidade"
                type="text"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                hide-details
                outlined
                :rules="[rules.required]"
                label="Bairro"
                v-model="currentResale.neighborhood"
                id="inputBairro"
                color="secondary"
                type="text"
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pa-6 pt-0 pb-3 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                hide-details
                outlined
                :rules="[rules.required]"
                label="Logradouro"
                color="secondary"
                v-model="currentResale.addressName"
                id="inputLogradouro"
                type="text"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                hide-details
                outlined
                label="Número"
                v-model="currentResale.addressNumber"
                color="secondary"
                id="AddressNumber"
                type="number"
                :required="true"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-checkbox
                hide-details
                outlined
                class="black--text"
                v-model="currentResale.addressNumber"
                label="Sem número"
                value="Sem número"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="4">
              <v-text-field
                outlined
                hide-details
                v-model="currentResale.resaleWebSite"
                label="Site (Opcional)"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pa-6 pt-0 pb-3 ma-0 space-between">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                hide-details
                outlined
                label="Complemento"
                v-model="currentResale.addressComplement"
                id="inputComplemento"
                color="secondary"
                :rules="[rules.required]"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card>

      <v-card v-if="true" class="mx-auto" >
        <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred">
          mdi-cash-multiple
        </v-icon>
        <span class="text-span" style="mx-auto">Informações do recebedor</span>

        <span class="pl-12 pb-2" style="display: block">
          Suas informações bancárias para receber seus pagamentos de comissões. Preencha
          todos os dados com atenção pois não será possível alterar depois, comprometendo
          seu pagamento.
        </span>
        <v-form
            class="form"
            :key="clear"
            ref="thirdForm"
            v-model="thirdValid"
            lazy-validation
        >
          <v-row align="end" class="pa-6 pb-3 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="E-mail do recebedor"
                  v-model="currentResale.eMailReceiver"
                  :label="'E-mail'"
                  :rules="[rules.required, rules.emailRules]"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-select
                  outlined
                  hide-details
                  :disabled="isEditing"
                  placeholder="Tipo de pessoa"
                  v-model="currentResale.typePersonReceiver"
                  :items="typesPersonReceiver"
                  item-text="descrption"
                  item-value="value"
                  :label="'Tipo de pessoa'"
                  :rules="[rules.required]"
              ></v-select>
            </v-col>

            <v-col v-if="currentResale.typePersonReceiver && currentResale.typePersonReceiver === typePersonReceiverIndividual" cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Nome do recebedor"
                  v-model="currentResale.individualName"
                  :label="'Nome do recebedor'"
                  :rules="[rules.required]"
                  required
              ></v-text-field>
            </v-col>

            <v-col v-if="currentResale.typePersonReceiver && currentResale.typePersonReceiver === typePersonReceiverCorporation" cols="12" sm="12" md="4" lg="4">
              <label>Receita anual da empresa</label>
              <div class="mr-3 ml-1" style="border: 1px solid #979797; border-radius: 7.5px;">
                <vuetify-money
                    color="black"
                    v-bind:outlined="outlined"
                    placeholder="0.00"
                    required
                    :rules="[rules.required]"
                    hide-details
                    dense
                    v-model="currentResale.annualRevenue"
                    v-bind:options="options"
                ></vuetify-money>
              </div>
            </v-col>
          </v-row>

          <v-row align="end" class="pa-6 pb-3 ma-0">
            <v-col v-if="currentResale.typePersonReceiver && currentResale.typePersonReceiver === typePersonReceiverIndividual" cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  type="date"
                  placeholder="Data de nascimento"
                  v-model="currentResale.individualBirthdate"
                  :label="'Data de nascimento'"
                  :rules="[rules.required]"
                  required
              ></v-text-field>
            </v-col>


            <v-col v-if="currentResale.typePersonReceiver && currentResale.typePersonReceiver === typePersonReceiverIndividual" cols="12" sm="12" md="4" lg="4">
              <label>Renda mensal</label>
              <div class="mr-3 ml-1" style="border: 1px solid #979797; border-radius: 7.5px;">
                <vuetify-money
                    color="black"
                    v-bind:outlined="outlined"
                    placeholder="0.00"
                    required
                    :rules="[rules.required]"
                    hide-details
                    dense
                    v-model="currentResale.individualMonthlyIncome"
                    v-bind:options="options"
                ></vuetify-money>
              </div>
            </v-col>

            <v-col v-if="currentResale.typePersonReceiver && currentResale.typePersonReceiver === typePersonReceiverIndividual" cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Ocupação profissional"
                  v-model="currentResale.individualProfessionalOccupation"
                  :label="'Ocupação profissional'"
                  :rules="[rules.required]"
                  required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row align="end" class="pa-6 pb-3 ma-0">
            <v-col v-if="currentResale.typePersonReceiver" cols="12" sm="12" md="4" lg="4">
                <v-text-field
                    clearable
                    outlined
                    hide-details
                    :placeholder="currentResale.typePersonReceiver === typePersonReceiverIndividual ? 'CPF do recebedor' : 'CNPJ do recebedor'"
                    v-model="currentResale.document"
                    :rules="currentResale.typePersonReceiver === typePersonReceiverIndividual ? [rules.required, rules.validateCPF] : [rules.required, rules.validateCNPJ]"
                    v-mask="currentResale.document.length <= 14  ? '###.###.###-##' : '##.###.###/####-##'"
                    :label="currentResale.typePersonReceiver === typePersonReceiverIndividual ? 'CPF do recebedor' : 'CNPJ do recebedor'"
                    rounded
                    required
                ></v-text-field>
            </v-col>

            <v-col v-if="currentResale.typePersonReceiver && currentResale.typePersonReceiver === typePersonReceiverCorporation" cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Nome fantasia do recebedor"
                  v-model="currentResale.companyNameReceiver"
                  :label="'Nome fantasia do recebedor'"
                  :rules="[rules.required]"
                  required
              ></v-text-field>
            </v-col>

            <v-col v-if="currentResale.typePersonReceiver && currentResale.typePersonReceiver === typePersonReceiverCorporation" cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Razão social da empresa"
                  v-model="currentResale.tradingNameReceiver"
                  :label="'Razão social da empresa'"
                  :rules="[rules.required]"
                  required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card>

      <v-card v-if="currentResale.typePersonReceiver && currentResale.typePersonReceiver === typePersonReceiverCorporation" class="mx-auto" >
        <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred">
          mdi-cash-multiple
        </v-icon>
        <span class="text-span" style="mx-auto">Informações do representante legal atrelado a empresa</span>

        <span class="pl-12 pb-2" style="display: block">
          Dados referentes ao representante legal vinculado à empresa,
          incluindo informações cadastrais e de identificação necessárias
          para comprovar sua legitimidade perante órgãos reguladores e parceiros comerciais.
        </span>
        <v-form
            class="form"
            :key="clear"
            ref="fourthForm"
            v-model="fourthValid"
            lazy-validation
        >
          <v-row align="end" class="pa-6 pb-3 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Nome do representante"
                  v-model="currentResale.managingPartnersName"
                  :label="'Nome do representante'"
                  :rules="[rules.required]"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="E-mail do representante"
                  v-model="currentResale.managingPartnersEmail"
                  :label="'E-mail do representante'"
                  :rules="[rules.required, rules.emailRules]"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="CPF do representante"
                  v-model="currentResale.managingPartnersDocument"
                  :rules="[rules.required, rules.validateCPF]"
                  v-mask="'###.###.###-##'"
                  :label="'CPF do representante'"
                  rounded
                  required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row align="end" class="pa-6 pb-3 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  type="date"
                  placeholder="Data de nascimento do representante"
                  v-model="currentResale.managingPartnersBirthdate"
                  :label="'Data de nascimento do representante'"
                  :rules="[rules.required]"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <label>Renda mensal declarada pelo representante</label>
              <div class="mr-3 ml-1" style="border: 1px solid #979797; border-radius: 7.5px;">
                <vuetify-money
                    color="black"
                    v-bind:outlined="outlined"
                    placeholder="0.00"
                    required
                    :rules="[rules.required]"
                    hide-details
                    dense
                    v-model="currentResale.managingPartnersMonthlyIncome"
                    v-bind:options="options"
                ></vuetify-money>
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Ocupação profissional do representante"
                  v-model="currentResale.managingPartnersProfessionalOccupation"
                  :rules="[rules.required]"
                  :label="'Ocupação profissional do representante'"
                  rounded
                  required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pa-6 pb-0 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <div style="display: flex">
                <div>
                  <v-text-field
                      outlined
                      label="CEP do representante"
                      placeholder="CEP do representante"
                      :rules="[rules.postalCodeRules]"
                      v-model="currentResale.managingPartnersZipCode"
                      v-on:keyup="searchCEPManagingPartners"
                      v-mask="'#####-###'"
                      class="inputCep"
                  ></v-text-field>
                  <p v-show="naoLocalizado" style="display: none; background-color: #f1948a">
                    <strong>CEP não localizado.</strong> Por gentileza entre manualmente.
                  </p>
                </div>

                <div class="ml-2">
                  <a
                    href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                    target="_blank"
                >Não sei meu CEP</a></div>
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-select
                  outlined
                  hide-details
                  :rules="[rules.required]"
                  :items="estados"
                  label="Estado do representante"
                  placeholder="Estado do representante"
                  v-model="currentResale.managingPartnersState"
                  color="secondary"
                  id="mb-8"
                  required
              ></v-select>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  :rules="[rules.required]"
                  label="Cidade do representante"
                  placeholder="Cidade do representante"
                  v-model="currentResale.managingPartnersAddressCity"
                  color="secondary"
                  id="inputCidade"
                  type="text"
                  required
              ></v-text-field>
            </v-col>
          </v-row>


          <v-row class="pa-6 pt-0 pb-3 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  hide-details
                  outlined
                  :rules="[rules.required]"
                  label="Bairro do representante"
                  placeholder="Bairro do representante"
                  v-model="currentResale.managingPartnersAddressNeighborhood"
                  id="inputBairro"
                  color="secondary"
                  type="text"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  hide-details
                  outlined
                  :rules="[rules.required]"
                  label="Logradouro do representante"
                  placeholder="Logradouro do representante"
                  color="secondary"
                  v-model="currentResale.managingPartnersAddressStreet"
                  id="inputLogradouro"
                  type="text"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  hide-details
                  outlined
                  label="Número do representante"
                  placeholder="Número do representante"
                  v-model="currentResale.managingPartnersAddressStreetNumber"
                  color="secondary"
                  id="AddressNumber"
                  type="number"
                  :rules="[rules.required]"
                  :required="true"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pa-6 pt-0 pb-3 ma-0 space-between">
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                  hide-details
                  outlined
                  label="Complemento do representante"
                  placeholder="Complemento do representante"
                  v-model="currentResale.managingPartnersAddressComplementary"
                  id="inputComplemento"
                  color="secondary"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card>

      <!--Bancários -->
      <v-card v-if="true" class="mx-auto" >
        <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
          >mdi-cash-multiple
        </v-icon>
        <span class="text-span" style="mx-auto">Informações Bancarias</span>

        <span class="pl-12 pb-2" style="display: block">
          Informações necessárias para identificar a pessoa ou empresa que receberá o pagamento.
        </span>
        <v-form
          class="form"
          :key="clear"
          ref="fifthForm"
          v-model="fifthValid"
          lazy-validation
        >
          <v-row class="pa-6 pb-3 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  placeholder="Titular da Conta"
                  v-model="currentResale.holderName"
                  :label="'Titular da Conta'"
                  :rules="[rules.required, (v) => v.length <= 30 || 'O nome do titular deve possuir 30 caracteres no máximo']"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  maxlength="3"
                  v-mask="'###'"
                  hint="Ex: 099"
                  persistent-hint
                  hide-details
                  placeholder="Código do Banco"
                  v-model="currentResale.bank"
                  :label="'Código do Banco'"
                  :rules="[rules.required, (v) => v.length >= 3 || 'O Código do Banco deve possuir no minimo 3 caracteres']"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  clearable
                  outlined
                  placeholder="Número da agência"
                  hide-details
                  maxlength="4"
                  type="number"
                  v-model="currentResale.branchMumber"
                  :rules="[rules.required]"
                  :label="'Número da agência'"
                  rounded
                  required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pa-6 pb-3 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  type="number"
                  hide-details
                  maxlength="2"
                  rounded
                  placeholder="Digito da agência"
                  v-model="currentResale.branchCheckDigit"
                  :label="'Digito da agência'"
                  :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  outlined
                  hide-details
                  maxlength="13"
                  v-mask="'#############'"
                  placeholder="Número da conta"
                  v-model="currentResale.accountNumberReceiver"
                  :label="'Número da conta'"
                  :rules="[rules.required]"
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  clearable
                  outlined
                  placeholder="Digito da conta"
                  hide-details
                  maxlength="2"
                  v-mask="'##'"
                  v-model="currentResale.accountCheckDigit"
                  :rules="[rules.required]"
                  :label="'Digitos da conta'"
                  rounded
                  required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="pa-6 pb-3 ma-0">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-text-field
                  clearable
                  outlined
                  hide-details
                  placeholder="CNPJ/CPF do titular da conta"
                  v-model="currentResale.holderDocument"
                  :rules="[rules.required, rules.validateCPF, rules.validateCNPJ]"
                  v-mask="currentResale.holderDocument.length <= 14  ? '###.###.###-##' : '##.###.###/####-##'"
                  :label="'CNPJ/CPF do titular da conta'"
                  rounded
                  required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="4" lg="4">
              <v-select
                  outlined
                  hide-details
                  placeholder="Tipo de conta"
                  v-model="currentResale.accountTypeReceiver"
                  :items="tipoConta"
                  item-text="descrption"
                  item-value="value"
                  :label="'Tipo de conta'"
                  :rules="[rules.required]"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card>

      <!--Login -->
      <v-card v-if="true" class="mx-auto">
        <v-icon class="d-flex-row justify-center pl-10 pt-3" large color="normalred"
          >mdi-lock-outline</v-icon
        >
        <span class="text-span" style="mx-auto">Informações de Login</span>

        <span class="pl-12 pb-2" style="display: block">
          Seu e-mail para login na plataforma de afiliado, e a sua senha.</span
        >

        <v-form
          class="form"
          :key="clear"
          ref="sixthForm"
          v-model="sixthValid"
          lazy-validation
        >
          <v-row class="pa-6 pb-3 ma-0">
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field
                outlined
                v-model="currentResale.email"
                :rules="[rules.emailRules]"
                :label="'E-mail'"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <v-text-field
                outlined
                v-model="currentResale.email2"
                :rules="[
                  rules.required,
                  rules.emailRules,
                  this.currentResale.email === this.currentResale.email2 ||
                    'Os e-mails devem ser iguais.',
                ]"
                :label="'Confirmação de e-mail'"
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row  >
            <v-col cols="12" sm="4" md="4" lg="4">
              <v-btn
                large
                class="d-flex justify-content-center"
                style="
                  border-radius: 8px !important;
                  width: max-content;
                  font-weight: bold;
                  font-size: 18px;
                  margin-left: 40px;
                "
                color="normalred"
                @click="openSubmit()"
                >Cadastrar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </div>
</template>

<style scoped>
.text-span {
  color: #000000;
  font-weight: bold;
  font-size: large;
}

.flex-end {
  justify-content: flex-end;
}

.space-between {
  justify-content: space-between;
}
.black--text /deep/ label {
  color: black;
  font-size: 15px;
}

.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box !important;
  border-radius: 8px !important;
  width: 100% !important;
}

.table-button {
  font-weight: bold !important;
  transition: 300ms !important;
}

.table-button:hover {
  background: #2d3038 !important ;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.mytable .v-table tbody tr {
  border-left: 5px solid red !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}

@media screen and (max-width: 700px) {
  .theme--light.v-data-table thead tr:last-child th,
  .theme--light.v-data-table tbody tr:not(:last-child) td:last-child,
  .theme--light.v-data-table tbody tr td,
  .theme--light.v-data-table tbody tr:not(:last-child) td:not(.v-data-table__mobile-row) {
    border-bottom: medium solid black !important;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import HeaderResale from "../components/HeaderResale.vue";
import Vue from "vue";
import bancosBrasil from "../../../../assets/bancosBrasil.json";
import Utils from "../../../../Utils/ValidateCPFCNPJ";
import moment from "moment";
import {findLatitudeAndLongitude} from "@/services/GoogleMaps";
export default {
  name: "ResalesRegistration",

  props: {
    resale: Object,
  },

  components: {
    HeaderResale,
  },

  data: () => ({
    editDialog: false,
    banks: [],
    cepMask: "",
    step: 1,
    clear: false,
    dialog: false,
    loading: false,
    isEditing: false,
    sucessDialog: false,
    postalCode: "",
    naoLocalizado: false,
    agreement: false,
    firstValid: true,
    secondValid: true,
    thirdValid: true,
    fourthValid: true,
    fifthValid: true,
    sixthValid: true,
    closeNoLoading: false,
    apiService: new ApiService(),
    regions: [
      "Nacional - Todas as Regiões",
      "Internacional",
      "Sul - Região 5",
      "Sudeste - Região 4",
      "Centro-Oeste - Região 3",
      "Nordeste - Região 2",
      "Norte - Região 1",
    ],
    status: ["Ativo", "Inativo"],
    categorias: ["Categoria 1", "Categoria 2", "Categoria 3", "Categoria 4"],
    daysOfTheMonth :['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
    daysOfTheWeek: [
      {
        day: '1',
        descrption: 'Segunda-feira'
      },
      {
        day: '2',
        descrption: 'Terça-feira'
      },
      {
        day: '3',
        descrption: 'Quarta-feira'
      },
      {
        day: '4',
        descrption: 'Quinta-feira'
      },
      {
        day: '5',
        descrption: 'Sexta-feira'
      }
    ],
    tipoConta: [
      {
        value: 'checking',
        descrption: 'Conta Corrente'
      },
      {
        value: 'savings',
        descrption: 'Poupança'
      },
    ],
    typesPersonReceiver: [
      {
        value: 'individual',
        descrption: 'Pessoa física'
      },
      {
        value: 'corporation',
        descrption: 'Pessoa jurídica'
      },
    ],
    tipoDocumento: [
      {
        value: 'individual',
        descrption: 'CPF'
      },
      {
        value: 'company',
        descrption: 'CNPJ'
      },
    ],
    frequenciaTransferencia: [
      {
        value: 'daily',
        descrption: 'Diária'
      },
      {
        value: 'weekly',
        descrption: 'Semanal'
      },
      {
        value: 'monthly',
        descrption: 'Mensal'
      }
    ],
    estados: [
      "AC",
      "AL",
      "AM",
      "AP",
      "BA",
      "CE",
      "DF",
      "ES",
      "GO",
      "MA",
      "MT",
      "MS",
      "MG",
      "PA",
      "PB",
      "PR",
      "PE",
      "PI",
      "RJ",
      "RN",
      "RO",
      "RS",
      "RR",
      "SC",
      "SE",
      "SP",
      "TO",
    ],
    currentResale: {
      name: "",
      agreement: false,
      cnpj: "",
      inscrEstadual: "",
      phoneNumber: "",
      phoneNumber2: "",
      birthDate: "",
      postalCode: "",
      state: "",
      city: "",
      neighborhood: "",
      addressName: "",
      addressNumber: "",
      country: "",
      addressComplement: "",
      resaleRegion: "",
      category: "",
      region: "",
      password: "",
      password2: "",
      email: "",
      email2: "",
      resaleWebSite: "",
      receiveEmail: false,
      receiveSms: "",
      textObservation: "",
      nameReceiver: "",
      individualName: "",
      eMailReceiver: "",
      description: "",
      document: "",
      companyNameReceiver: "",
      tradingNameReceiver: "",
      typeReceiver: "",
      codeReceiver: "",
      holderName: "",
      bank: "",
      branchMumber: "",
      branchCheckDigit: "",
      accountNumberReceiver: "",
      accountCheckDigit: "",
      holderYype: "",
      holderDocument: "",
      transferEnabled: false,
      transferInterval: "monthly",
      transferDay: 7,
      gatewayRecipientsStatus: "",
      accountTypeReceiver: "",
      percentagePaidToPlatform: 0.00,
      typePersonReceiver: null,
      individualBirthdate: null,
      annualRevenue: 0.00,
      individualMonthlyIncome: 0.00,
      individualProfessionalOccupation: null,
      managingPartnersName: null,
      managingPartnersEmail: null,
      managingPartnersDocument: null,
      managingPartnersBirthdate: null,
      managingPartnersMonthlyIncome: 0.00,
      managingPartnersProfessionalOccupation: null,
      managingPartnersSelfDeclaredLegalRepresentative: true,
      managingPartnersAddressStreet: null,
      managingPartnersAddressComplementary: null,
      managingPartnersAddressStreetNumber: null,
      managingPartnersAddressNeighborhood: null,
      managingPartnersAddressCity: null,
      managingPartnersState: null,
      managingPartnersZipCode: null,
      managingPartnersReferencePoint: null,
      managingPartnersPhone: null,
      status: 0
    },
    typePersonReceiverIndividual: 'individual',
    typePersonReceiverCorporation: 'corporation',
    rules: {
      nameRules: (v) => (v && v.length < 45) || "Nome deve ter no máximo 45 caracteres",

      emailRules: (v) => /.+@.+\..+/.test(v) || "E-mail inválido",

      postalCodeRules: (v) =>
        (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",

      neighborhoodRules: (v) =>
        (v && v.length <= 30) || "Bairro deve ter no máximo 30 caracteres",

      addressRules: (v) =>
        (v && v.length <= 64) || "Logradouro deve ter no máximo 64 caracteres",

      complementRules: (v) =>
        (v && v.length <= 64) || "Complemento deve ter no máximo 64 caracteres",

      required: (value) => !!value || "Campo requerido.",
      maxValue: (v) => v <= 100 || "Maximo 100.",

      min: (v) => v.length >= 4 || "Minimo de 4 caracteres.",
      minPhone: (v) => v.length >= 15 || "Minimo de 8 caracteres.",

      stateRules: (v) =>
        (v && v.length <= 32) || "Estado deve ter no máximo 32 caracteres",

      cityRules: (v) =>
        (v && v.length <= 32) || "Cidade deve ter no máximo 32 caracteres",

      validateCPF: (value) =>  (Utils.CPF(value) || value.toString().replace(/\D/g, "").length > 11) || 'Cpf Inválido',
      validateCNPJ: (value) => (Utils.CNPJ(value) || value.toString().replace(/\D/g, "").length <= 11 ) || 'Cnpf Inválido'
    },
    outlined: true,
    options: {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 11,
      precision: 2
    },
  }),

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },



  methods: {
    async openSubmit() {
      try {
        if (
            this.$refs.firstForm.validate() &&
            this.$refs.secondForm.validate() &&
            this.$refs.thirdForm.validate() &&
            this.$refs.fifthForm.validate() &&
            this.$refs.sixthForm.validate()
        ) {
          if (this.currentResale.typePersonReceiver === this.typePersonReceiverIndividual) {
            await this.add()
            return
          }
          if (this.$refs.fourthForm.validate()) {
            await this.add()
            return
          }
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: "Formulário não validado",
            trace: null,
          });
        } else {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro",
            message: "Formulário não validado",
            trace: null,
          });
        }
      } catch (e) {
        console.log('e')
        console.log(e)
        console.log('e')
      }
    },

    async add() {
      const {lat,lng} = await findLatitudeAndLongitude(this.currentResale);
      this.currentResale.latitude = lat != null ? parseFloat(lat) : null;
      this.currentResale.longitude = lng != null ? parseFloat(lng) : null;

      await this.apiService
          .post('resale/add', this.currentResale)
          .then((resp) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: "Cadastro atualizado com sucesso!",
              message: "Cadastro feito com sucesso!",
              trace: null,
            });
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro",
              message: err.body ? err.body.message : 'Não foi possível cadastrar a revenda',
              trace: null,
            });

            this.loading = false;
          });
    },

    async validate() {
      this.loading = true;

      const userValid = {
        Cnpj: this.currentResale.cnpj,
        Email: this.currentResale.email,
        Name: this.currentResale.name,
        PhoneNumber: this.currentResale.phoneNumber,
        PhoneNumber2: this.currentResale.phoneNumber2,
      };

      await this.apiService
        .post("resale/validate", userValid)
        .then(() => {
          if (this.true) {
            this.sucessDialog = true;
          } else if (this.step != 3) {
            this.step += 1;
          }
          this.loading = false;
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: err.body.message,
            message: "",
            trace: null,
          });

          this.loading = false;
        });
    },

    async searchCEP() {
      this.cepMask = "#####-###";
      if (/^[0-9]{5}-[0-9]{3}$/.test(this.currentResale.postalCode)) {
        var self = this;
        self.naoLocalizado = false;
        self.location = {};
        var client = new ApiService();
        await client
          .get(`user/postalcode?cep=${this.currentResale.postalCode}`)
          .then((response) => {
            const location = JSON.parse(response);

            if (location.erro) {
              self.location = {};
              this.naoLocalizado = true;
              this.currentResale.neighborhood = "";
              this.currentResale.address = "";
              this.currentResale.city = "";
              this.currentResale.state = "";
              this.currentResale.addressNumber = "";
              this.currentResale.country = "Brasil";
              this.currentResale.addressName = "";
              return;
            }

            this.currentResale.neighborhood = location.bairro;
            this.currentResale.addressName = location.logradouro;
            this.currentResale.city = location.localidade;
            this.currentResale.state = location.uf;
            this.currentResale.country = "Brasil";
            document.getElementById("AddressNumber").focus();

            return;
          });
      }
    },

    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },

    async searchCEPManagingPartners() {
      this.cepMask = "#####-###";
      if (/^[0-9]{5}-[0-9]{3}$/.test(this.currentResale.managingPartnersZipCode)) {
        var self = this;
        self.naoLocalizado = false;
        self.location = {};
        var client = new ApiService();
        await client
          .get(`user/postalcode?cep=${this.currentResale.managingPartnersZipCode}`)
          .then((response) => {
            const location = JSON.parse(response);

            if (location.erro) {
              self.location = {};
              this.naoLocalizado = true;
              this.currentResale.neighborhood = "";
              this.currentResale.address = "";
              this.currentResale.city = "";
              this.currentResale.state = "";
              this.currentResale.addressNumber = "";
              this.currentResale.country = "Brasil";
              this.currentResale.addressName = "";
              return;
            }

            this.currentResale.managingPartnersAddressNeighborhood = location.bairro;
            this.currentResale.managingPartnersAddressStreet = location.logradouro;
            this.currentResale.managingPartnersAddressCity = location.localidade;
            this.currentResale.managingPartnersState = location.uf;
            this.currentResale.country = "Brasil";

            return;
          });
      }
    },

    close() {
      this.loading = true;
      this.$emit("close");

      this.loading = false;
    },

    bancosBrasil() {
      var bancos = [];

      bancosBrasil.forEach((bank) => {
        bancos.push(bank.COMPE + "-" + bank.ShortName);
      });

      this.banks = bancos;

      return this.banks;
    },

    voltar(rota) {
      this.$router.push("/resales");
    },

    async goTo(rota) {
      let token = localStorage.getItem("token");
      if (token) {
        this.$router.push("/" + rota);
      } else {
        this.$router.push("/auth");
      }
      await this.updateTable();
    },

    async updateTable() {
      this.loading = true;
      this.isLoading = true;
      await this.apiService.post(`resale/list`, this.filter).then((response) => {
        this.totalPages = response.pager.totalPages;
        this.resales = response.resales;
        this.loading = false;
        this.isLoading = false;
      });
    },
  },

  async created() {
    this.loading = true;

    await this.apiService
      .get(`resale/get-one?id=` + this.$route.query.id)
      .then((response) => {
        if (response.body !== "") {
          this.isEditing = true;
          this.currentResale = response;
          console.log(this.currentResale)
          if (this.currentResale.managingPartnersBirthdate){
            this.currentResale.managingPartnersBirthdate = moment(this.currentResale.managingPartnersBirthdate).format("YYYY-MM-DD");
          }
          if (this.currentResale.individualBirthdate){
            this.currentResale.individualBirthdate = moment(this.currentResale.individualBirthdate).format("YYYY-MM-DD");
          }
        }
      });
  },
};
</script>
